import { useStaggeredReveal } from "../../../hooks/use-scroll-reveal";

import style from "./style.module.scss";

interface Step {
  number: string;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: "01",
    title: "Uploadez vos photos",
    description: "Sélectionnez vos plus belles photos depuis votre téléphone ou ordinateur",
  },
  {
    number: "02",
    title: "Personnalisez",
    description: "Arrangez, recadrez et ajoutez des légendes à chaque page",
  },
  {
    number: "03",
    title: "Recevez chez vous",
    description: "Imprimé en haute qualité et livré partout en Algérie",
  },
];

function ProcessSection() {
  const gridRef = useStaggeredReveal<HTMLDivElement>(200);

  return (
    <section className={style.process}>
      <div className={style.processInner}>
        <h2 className={style.processTitle}>Comment ça marche</h2>
        <div ref={gridRef} className={style.processGrid}>
          {steps.map((step) => (
            <div key={step.number} className={style.processStep}>
              <span className={style.processNumber}>{step.number}</span>
              <h3 className={style.processStepTitle}>{step.title}</h3>
              <p className={style.processStepDesc}>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
